import api from '@/libs/api'
import store from '@/store'
import helpers from '@/mixins/helpers'

const getProjectId = () => store.state.app.projectId
export default {
  namespaced: true,
  state: {
    loadingTrafficSum: false,
    loadingHitMissesSum: false,
    loadingHitMisses: false,
    loadginBandwidth: false,
    loadingTraffic: false,
    loadingStatusCodes: false,
    loadingStatusCodesDetails: false,
    loadingBandwidthPercentile: false,
    loadingHitMissesDetails: false,
    hitMissesCachedData: { percentValue: null, number: null },
    hitMissesNoCacheData: { percentValue: null, number: null },
    bandwidthCachedData: { percentValue: null, number: null },
    bandwidthNoCacheData: { percentValue: null, number: null },
    totalHitRatioPercentage: '-',
    trafficCachedData: { percentValue: null, number: null },
    trafficNoCacheData: { percentValue: null, number: null },
    // status code responses
    successResponse: {
      percentValue: null, number: null,
    },
    warningResponse: {
      percentValue: null, number: null,
    },
    clientErrorResponse: {
      percentValue: null, number: null,
    },
    serverErrorResponse: {
      percentValue: null, number: null,
    },
    trafficSum: [],
    hitMissesSum: [],
    hitMisses: [],
    bandwidth: [],
    traffic: [],
    statusCodes: [],
    statusCodesDetails: [],
    hitMissesDetails: [],
    bandwidthPercentile: 0,
  },
  mutations: {
    LOADING_TRAFFIC_SUM(state, value) {
      state.loadingTrafficSum = value
    },
    LOADING_HIT_MISSES_SUM(state, value) {
      state.loadingHitMissesSum = value
    },
    LOADING_HIT_MISSES(state, value) {
      state.loadingHitMisses = value
    },
    LOADING_HIT_MISSES_DETAILS(state, value) {
      state.loadingHitMissesDetails = value
    },
    LOADING_BANDWIDTH(state, value) {
      state.loadginBandwidth = value
    },
    LOADING_TRAFFIC(state, value) {
      state.loadingTraffic = value
    },
    LOADING_STATUS_CODES(state, value) {
      state.loadingStatusCodes = value
    },
    LOADING_STATUS_CODES_DETAILS(state, value) {
      state.loadingStatusCodesDetails = value
    },
    LOADING_BANDWIDTH_PERCENTILE(state, value) {
      state.loadingBandwidthPercentile = value
    },
    SET_TRAFFIC_SUM(state, value) {
      state.trafficSum = value
    },
    SET_HIT_MISSES_SUM(state, value) {
      state.hitMissesSum = value
    },
    SET_HIT_MISSES(state, value) {
      state.hitMisses = value
      if (value.total > 0) {
        state.totalHitRatioPercentage = helpers.methods.calculateDataRatio(value.total, value.result[0].total)
      }
      const responseKeys = ['hitMissesCachedData', 'hitMissesNoCacheData']
      helpers.methods.updateStateWithValues(state, value, responseKeys)
    },
    SET_HIT_MISSES_DETAILS(state, value) {
      state.hitMissesDetails = value
    },
    SET_BANDWIDTH(state, value) {
      state.bandwidth = value
      const responseKeys = ['bandwidthCachedData', 'bandwidthNoCacheData']
      helpers.methods.updateStateWithValues(state, value, responseKeys)
    },
    SET_TRAFFIC(state, value) {
      state.traffic.push(value)
      const responseKeys = ['trafficCachedData', 'trafficNoCacheData']
      helpers.methods.updateStateWithValues(state, value, responseKeys)
    },
    SET_STATUS_CODES(state, value) {
      state.statusCodes = value
      const responseKeys = ['successResponse', 'warningResponse', 'clientErrorResponse', 'serverErrorResponse']
      helpers.methods.updateStateWithValues(state, value, responseKeys)
    },
    SET_STATUS_CODES_DETAILS(state, value) {
      state.statusCodesDetails = value
    },
    SET_BANDWIDTH_PERCENTILE(state, value) {
      state.bandwidthPercentile = value.percentile
    },
    RESET_TRAFFIC(state) {
      state.traffic = []
    },
  },
  actions: {
    fetchTrafficSum({ commit }, query) {
      commit('LOADING_TRAFFIC_SUM', true)
      return new Promise((resolve, reject) => {
        api('cdnV2')
          .post(`/projects/${getProjectId()}/distributions/analytics/traffic/sum`, query)
          .then(response => {
            commit('SET_TRAFFIC_SUM', response.data.result)
            resolve(response)
          })
          .catch(err => {
            this.trafficSum = []
            reject(err)
          })
          .finally(() => {
            commit('LOADING_TRAFFIC_SUM', false)
          })
      })
    },
    fetchHitMissesSum({ commit }, query) {
      commit('LOADING_HIT_MISSES_SUM', true)
      return new Promise((resolve, reject) => {
        api('cdnV2')
          .post(`/projects/${getProjectId()}/distributions/analytics/hit-misses/sum`, query)
          .then(response => {
            commit('SET_HIT_MISSES_SUM', response.data.result)
            resolve(response)
          })
          .catch(err => {
            this.hitMissesSum = []
            reject(err)
          })
          .finally(() => {
            commit('LOADING_HIT_MISSES_SUM', false)
          })
      })
    },
    fetchHitMisses({ commit }, query) {
      commit('LOADING_HIT_MISSES', true)
      return new Promise((resolve, reject) => {
        api('cdnV2')
          .post(`/projects/${getProjectId()}/distributions/analytics/hit-misses`, query)
          .then(response => {
            commit('SET_HIT_MISSES', response.data.result)
            resolve(response)
          })
          .catch(err => {
            this.hitMisses = []
            reject(err)
          })
          .finally(() => {
            commit('LOADING_HIT_MISSES', false)
          })
      })
    },
    fetchHitMissesDetails({ commit }, query) {
      commit('LOADING_HIT_MISSES_DETAILS', true)
      return new Promise((resolve, reject) => {
        api('cdnV2')
          .post(`/projects/${getProjectId()}/distributions/analytics/hit-misses/details`, query)
          .then(response => {
            commit('SET_HIT_MISSES_DETAILS', response.data.result)
            resolve(response)
          })
          .catch(err => {
            this.hitMisses = []
            reject(err)
          })
          .finally(() => {
            commit('LOADING_HIT_MISSES_DETAILS', false)
          })
      })
    },
    fetchBandwidth({ commit }, query) {
      commit('LOADING_BANDWIDTH', true)
      return new Promise((resolve, reject) => {
        api('cdnV2')
          .post(`/projects/${getProjectId()}/distributions/analytics/bandwidth`, query)
          .then(response => {
            commit('SET_BANDWIDTH', response.data.result)
            resolve(response)
          })
          .catch(err => {
            this.bandwidth = []
            reject(err)
          })
          .finally(() => {
            commit('LOADING_BANDWIDTH', false)
          })
      })
    },
    fetchTraffic({ commit }, query) {
      commit('LOADING_TRAFFIC', true)
      return new Promise((resolve, reject) => {
        api('cdnV2')
          .post(`/projects/${getProjectId()}/distributions/analytics/traffic`, query)
          .then(response => {
            commit('SET_TRAFFIC', response.data.result)
            resolve(response)
          })
          .catch(err => {
            this.traffic = []
            reject(err)
          })
          .finally(() => {
            commit('LOADING_TRAFFIC', false)
          })
      })
    },
    fetchStatusCodes({ commit }, query) {
      commit('LOADING_STATUS_CODES', true)
      return new Promise((resolve, reject) => {
        api('cdnV2')
          .post(`/projects/${getProjectId()}/distributions/analytics/status-codes`, query)
          .then(response => {
            commit('SET_STATUS_CODES', response.data.result)
            resolve(response)
          })
          .catch(err => {
            this.statusCodes = []
            reject(err)
          })
          .finally(() => {
            commit('LOADING_STATUS_CODES', false)
          })
      })
    },
    fetchStatusCodesDetails({ commit }, query) {
      commit('LOADING_STATUS_CODES_DETAILS', true)
      return new Promise((resolve, reject) => {
        api('cdnV2')
          .post(`/projects/${getProjectId()}/distributions/analytics/status-codes/details`, query)
          .then(response => {
            commit('SET_STATUS_CODES_DETAILS', response.data.result)
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('LOADING_STATUS_CODES_DETAILS', false)
          })
      })
    },
    fetchBandwidthPercentile({ commit }, query) {
      commit('LOADING_BANDWIDTH_PERCENTILE', true)
      return new Promise((resolve, reject) => {
        api('cdnV2')
          .post(`/projects/${getProjectId()}/distributions/analytics/bandwidth/percentile`, query)
          .then(response => {
            commit('SET_BANDWIDTH_PERCENTILE', response.data.result)
            resolve(response)
          })
          .catch(err => {
            reject(err)
          })
          .finally(() => {
            commit('LOADING_BANDWIDTH_PERCENTILE', false)
          })
      })
    },
  },
}
